import { html, type TemplateResult } from 'lit';

/**
 * 404 fallback rendered by the top-level router when no route matches the
 * current path (or a route fails to render).
 */
export const NotFoundPage = (): TemplateResult => html`
  <div
    class="bg-base-200 flex min-h-screen w-full flex-col items-center justify-center gap-6 px-4 py-16 text-center antialiased"
  >
    <div class="flex flex-col items-center gap-2">
      <span class="icon-[material-symbols--error-outline] text-base-content/30 text-5xl" aria-hidden="true"></span>
      <p class="text-base-content text-6xl font-semibold tracking-tight tabular-nums">404</p>
      <h1 class="text-base-content text-xl font-semibold">Page not found</h1>
      <p class="text-base-content/60 max-w-sm text-pretty">
        The page you're looking for doesn't exist or may have moved.
      </p>
    </div>
    <a href="/" class="btn btn-primary gap-2">
      <span class="icon-[material-symbols--arrow-back] text-lg" aria-hidden="true"></span> Back to generate
    </a>
  </div>
`;
